// extracted by mini-css-extract-plugin
export default {"container":"checkout-address_container__fcGxf","addressInfo":"checkout-address_addressInfo__TF63Y","title":"checkout-address_title__kE9uT","span":"checkout-address_span__XXv8F"};